import { createStore as reduxCreateStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { areaCodeReducer } from '../store/reducers/areaCodeReducer'
import { customerTypeReducer } from '../store/reducers/customerTypeReducer'
import thunk from 'redux-thunk'

const createStore = () => reduxCreateStore(
    combineReducers({areaCodeReducer, customerTypeReducer}),
    composeWithDevTools(applyMiddleware(thunk))
)
export default createStore
